// IIFE to avoid polluting the global namespace
(function () {
	document.addEventListener("DOMContentLoaded", function () {
		//*****************************************
		// Mobile Nav - requires plugins/bodyscrolllock.js
		//*****************************************

		var mobileNavDrawer = document.querySelector(".c-mobile-nav__drawer");

		var mobileNav = document.getElementById("mobile-nav"),
			mobileNavTarget = document.querySelectorAll(".js-mobileNavTarget"),
			mobileNavToggle = document.querySelectorAll(".js-mobileNavToggle"),
			activeClass = "is-active",
			bMobileNavActive = false;

		function toggleMobileNav() {
			if (bMobileNavActive) {
				deactivateMobileNav();
			} else {
				activateMobileNav();
			}
		}

		//removes active class from .js-mobileNavTarget elements
		//enables body scroll again
		function deactivateMobileNav() {
			bMobileNavActive = false;
			mobileNavTarget.forEach(function (element) {
				element.classList.remove(activeClass);
			});
			bodyScrollLock.enableBodyScroll(mobileNavDrawer);
		}

		//adds active class to .js-mobileNavTarget elements
		//disables body scroll
		function activateMobileNav() {
			bMobileNavActive = true;
			mobileNavTarget.forEach(function (element) {
				element.classList.add(activeClass);
			});
			bodyScrollLock.disableBodyScroll(mobileNavDrawer);
		}

		// Add click event listener to each .js-mobileNavToggle element
		mobileNavToggle.forEach(function (element) {
			element.addEventListener("click", function () {
				toggleMobileNav();
			});
		});

		// Deactivate mobile nav on window resize
		window.addEventListener("resize", function () {
			if (bMobileNavActive) {
				deactivateMobileNav();
			}
		});
	});
})();
